@if (!isLoading) {
    <div class="date-navigator-container">
        <div class="date-navigator-left">
            <button mat-mini-fab color="background" [disabled]="isLoading" (click)="navigatePrevious.emit()">
                <mat-icon>chevron_left</mat-icon>
            </button>
            <button mat-mini-fab color="background" [disabled]="isLoading" (click)="navigateNext.emit()">
                <mat-icon>chevron_right</mat-icon>
            </button>
            <div id="date-title">
                <span>{{ label }}</span>
            </div>
        </div>

        <div class="date-navigator-right">
            @if (!disabled) {
                <button mat-mini-fab color="background" class="mini-fab-extended"
                        (click)="resetToCurrent.emit()"
                        [disabled]="isLoading || isCurrentDate">
                    <span class="mini-fab-label">{{ 'date-navigator.today' | translate }}</span>
                    <mat-icon>today</mat-icon>
                </button>
            }
            <div class="date-navigator-picker">
                <button mat-mini-fab color="background" (click)="picker.open()" [disabled]="isLoading">
                    <mat-icon>calendar_today</mat-icon>
                </button>
                <input
                    #dateInput
                    matInput
                    [matDatepicker]="picker"
                    class="visually-hidden"
                    (dateChange)="onDateChange($event)"
                />
                <mat-datepicker
                    #picker
                    [startView]="pickerStartView"
                    panelClass="mini-calendar"
                    [startAt]="firstDayOfPeriod"
                    class="visually-hidden"
                    (monthSelected)="onMonthSelected($event, picker)"
                ></mat-datepicker>
            </div>
        </div>
    </div>
}
